var map = {
	"./banner-desktop.png": 8345,
	"./banner-tablet.png": 1480,
	"./banner.png": 1741,
	"./carousel-1.png": 3812,
	"./carousel-2.png": 7981,
	"./carousel-3.png": 1699,
	"./community-desktop.png": 9621,
	"./community-tablet.png": 1934,
	"./community.png": 7645,
	"./course-1.png": 9945,
	"./course-2.png": 5411,
	"./course-3.png": 6655,
	"./course-4.png": 2055,
	"./course-pattern-bottom.png": 7766,
	"./course-pattern-middle.png": 8525,
	"./course-pattern-top.png": 2633,
	"./hero-desktop.png": 5747,
	"./hero-tablet.png": 29,
	"./hero.png": 2344,
	"./isracover.png": 3498,
	"./lead-cover.png": 7342,
	"./logo-wakanda.png": 9063,
	"./review-1-mobile.png": 3139,
	"./review-1.png": 9537,
	"./review-2-mobile.png": 3582,
	"./review-2.png": 4602,
	"./review-3-mobile.png": 7815,
	"./review-3.png": 1144,
	"./video-1.png": 7610,
	"./video-2.png": 1912,
	"./video-texture.png": 7822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;